import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import { GetSsoToken } from './Session';
import {useSearchParams} from "react-router-dom";
import { useAuthDataContext } from "../AuthDataProvider";

export default function AuthLoginPage() {
  const { onLogin } = useAuthDataContext();
  
  const [redirectURL, setRedirectURL] = useState(null)
  const [searchParams] = useSearchParams();

  const code = searchParams.get('code')
  
  useEffect(() => {
    if(code){
    GetSsoToken(code)
      .then((result) => {
        onLogin(result)
        setRedirectURL("/")
      }
      ).catch((error) => {
        // TODO: add error message upon failed login
        console.log(error)
        setRedirectURL("/login")
      }
      )}
  }, [code]);

  if (redirectURL) {
    window.location.href = redirectURL;
    return null;
  } else {
    return (
      <Container maxWidth="lg" className="container">
        <br />
        <Paper spacing={3}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '25vh' }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <h1>Login</h1>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                  <CircularProgress size={48} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    )
  }
}
